import Model from "./Model";
import { Position } from "./Position";
import { ScoutingMetadata } from "./Scouting";

export class ScoutingAreaFilter {
  term?: string;
  granularity?: string;

  toParams() {
    const params = [];
    if (this.term) {
      params.push(`filter[term]=${encodeURIComponent(this.term)}`);
    }
    if (this.granularity) {
      params.push(
        `filter[granularity]=${encodeURIComponent(this.granularity)}`
      );
    }

    const base = "?include=*";
    if (params.length > 0) {
      return `${base}&${params.join("&")}`;
    }
    return base;
  }

  toPostParams() {
    const params = {
      filter: {
        term: this.term,
        granularity: this.granularity,
      },
    };

    return params;
  }
}

export interface Polygon {
  positions: Position[];
}

export default class ScoutingArea extends Model {
  static type = "scoutingArea";

  name!: string;
  description = "";
  sourceableId!: string;
  sourceableType!: string;
  multiPolygon!: any[];
  highlighted = false;
  metadata?: ScoutingMetadata;

  get key(): string {
    return this.sourceableId + "_" + this.sourceableType;
  }

  static makeKey(sourceableId: string, sourceableType: string) {
    return `${sourceableId}_${sourceableType}`;
  }
}
